import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmt, fmtD, Tag, Btn, Inp, Sel } from "../shared";
import { IMMEUBLES, INIT_AGS } from "../data";

export const AGPage = ({ residents, immId }) => {
  const [ags, setAgs] = useState(INIT_AGS);
  const [view, setView] = useState("list"); // "list" | "create" | "pv" | "detail"
  const [selected, setSelected] = useState(null);
  const [pvMode, setPvMode] = useState(false);

  // Create AG form state
  const [form, setForm] = useState({
    titre:"", date:"", heure:"18h00", lieu:"", type:"AGO",
    president:"", secretaire:"",
  });
  const [points, setPoints] = useState([]);
  const [newPoint, setNewPoint] = useState({titre:"", type:"vote", notes:""});
  const [presentsIds, setPresentsIds] = useState([]);
  const [currentStep, setCurrentStep] = useState(1); // 1=infos, 2=présences, 3=points, 4=votes

  const imm = IMMEUBLES.find(i => i.id === immId);
  const immRes = residents.filter(r => r.immId === immId);
  const agList = ags.filter(a => a.immId === immId);

  const addPoint = () => {
    if (!newPoint.titre.trim()) return;
    setPoints(p => [...p, {id: Date.now(), ...newPoint, pour:0, contre:0, abstention:0, decision:""}]);
    setNewPoint({titre:"", type:"vote", notes:""});
  };

  const removePoint = id => setPoints(p => p.filter(x => x.id !== id));

  const vote = (ptId, field, val) => {
    setPoints(p => p.map(pt => pt.id === ptId ? {...pt, [field]: Math.max(0, val)} : pt));
  };

  const finalizeVotes = () => {
    setPoints(p => p.map(pt => {
      if (pt.type !== "vote") return pt;
      const dec = pt.pour > pt.contre ? "Approuvé" : pt.pour < pt.contre ? "Rejeté" : "Nul";
      return {...pt, decision: dec};
    }));
  };

  const saveAG = () => {
    finalizeVotes();
    const newAG = {
      id: Date.now(), immId,
      ...form,
      statut:"Clôturée",
      presentsIds,
      quorum: presentsIds.length >= Math.ceil(immRes.length / 2),
      prochaineDate: null,
      points: points.map(pt => {
        if (pt.type !== "vote") return pt;
        const dec = pt.pour > pt.contre ? "Approuvé" : pt.pour < pt.contre ? "Rejeté" : "Nul";
        return {...pt, decision: dec};
      }),
    };
    setAgs(prev => [...prev, newAG]);
    setSelected(newAG);
    setView("pv");
  };

  const typeColor = t => t === "AGO" ? [C.blueL, C.blue] : ["#f3e8ff","#7c3aed"];
  const statutColor = s => s === "Clôturée" ? ["#d1fae5","#065f46"] : ["#fff3cd","#92400e"];

  /* ─── LIST VIEW ─── */
  if (view === "list") return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Assemblées Générales</h2>
          <p style={{color:C.muted,fontSize:13}}>{imm?.nom} · {agList.length} AG enregistrées</p>
        </div>
        <Btn onClick={() => { setForm({titre:"",date:"",heure:"18h00",lieu:"",type:"AGO",president:"",secretaire:""}); setPoints([]); setPresentsIds([]); setCurrentStep(1); setView("create"); }}>
          + Nouvelle AG
        </Btn>
      </div>

      {agList.length === 0 ? (
        <div style={{background:C.card,borderRadius:16,padding:60,textAlign:"center",boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
          <p style={{fontSize:40,marginBottom:12}}>🗳️</p>
          <p style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:6}}>Aucune AG enregistrée</p>
          <p style={{fontSize:13,color:C.muted}}>Créez votre première assemblée générale pour commencer.</p>
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {agList.sort((a,b) => new Date(b.date) - new Date(a.date)).map((ag, i) => (
            <div key={ag.id} className="fu ch" style={{animationDelay:`${i*60}ms`,background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                    <span style={{background:typeColor(ag.type)[0],color:typeColor(ag.type)[1],padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{ag.type}</span>
                    <span style={{background:statutColor(ag.statut)[0],color:statutColor(ag.statut)[1],padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{ag.statut}</span>
                    {ag.quorum && <span style={{background:"#d1fae5",color:"#065f46",padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>✓ Quorum</span>}
                  </div>
                  <h3 style={{fontSize:17,fontWeight:800,color:C.text,marginBottom:5}}>{ag.titre}</h3>
                  <div style={{display:"flex",gap:20,fontSize:13,color:C.muted}}>
                    <span>📅 {fmtD(ag.date)} à {ag.heure}</span>
                    <span>📍 {ag.lieu}</span>
                    <span>👥 {ag.presentsIds.length}/{immRes.length} présents</span>
                    <span>📋 {ag.points.length} point(s)</span>
                  </div>
                </div>
                <div style={{display:"flex",gap:8,marginLeft:20}}>
                  <button className="btn" onClick={() => { setSelected(ag); setView("detail"); }}
                    style={{padding:"8px 16px",borderRadius:10,background:C.blueL,color:C.blue,fontWeight:600,fontSize:13}}>
                    Voir détail
                  </button>
                  <button className="btn" onClick={() => { setSelected(ag); setView("pv"); }}
                    style={{padding:"8px 16px",borderRadius:10,background:`linear-gradient(135deg,${C.teal},#0ba882)`,color:"#fff",fontWeight:600,fontSize:13}}>
                    📄 PV
                  </button>
                </div>
              </div>
              <div style={{display:"flex",gap:8,marginTop:14,flexWrap:"wrap"}}>
                {ag.points.filter(p => p.type === "vote").map(p => (
                  <div key={p.id} style={{display:"flex",alignItems:"center",gap:6,background:C.bg,borderRadius:8,padding:"5px 10px",fontSize:12}}>
                    <span style={{fontWeight:600,color:C.text}}>{p.titre.length > 30 ? p.titre.slice(0,30)+"…" : p.titre}</span>
                    <span style={{background:p.decision==="Approuvé"?"#d1fae5":p.decision==="Rejeté"?"#fee2e2":"#f3f4f6",
                      color:p.decision==="Approuvé"?"#065f46":p.decision==="Rejeté"?"#991b1b":"#374151",
                      padding:"1px 7px",borderRadius:10,fontSize:10,fontWeight:700}}>
                      {p.decision || "—"}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  /* ─── CREATE AG ─── */
  if (view === "create") return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:22}}>
        <button className="btn" onClick={() => setView("list")}
          style={{padding:"8px 14px",borderRadius:10,background:C.bg,color:C.muted,fontWeight:600,fontSize:13}}>
          ← Retour
        </button>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Nouvelle Assemblée Générale</h2>
          <p style={{color:C.muted,fontSize:13}}>{imm?.nom}</p>
        </div>
      </div>

      {/* Steps indicator */}
      <div style={{display:"flex",gap:0,marginBottom:28,background:C.card,borderRadius:14,padding:6,boxShadow:"0 2px 10px rgba(11,19,51,.05)"}}>
        {[{n:1,l:"Informations"},{n:2,l:"Présences"},{n:3,l:"Points à l'ordre du jour"},{n:4,l:"Votes & Décisions"}].map(s => (
          <button key={s.n} className="btn" onClick={() => setCurrentStep(s.n)}
            style={{flex:1,padding:"9px 8px",borderRadius:10,fontSize:13,fontWeight:600,
              background:currentStep===s.n?C.teal:"transparent",
              color:currentStep===s.n?"#fff":currentStep>s.n?C.green:C.muted,
              display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
            <span style={{width:20,height:20,borderRadius:"50%",background:currentStep===s.n?"rgba(255,255,255,.25)":currentStep>s.n?`${C.green}22`:`${C.muted}18`,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700}}>
              {currentStep > s.n ? "✓" : s.n}
            </span>
            {s.l}
          </button>
        ))}
      </div>

      {/* Step 1 – Informations */}
      {currentStep === 1 && (
        <div className="fi" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:18}}>Informations générales</h4>
            <Inp label="Titre de l'AG" value={form.titre} onChange={v => setForm({...form,titre:v})} placeholder="Assemblée Générale Ordinaire 2024" />
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Inp label="Date" type="date" value={form.date} onChange={v => setForm({...form,date:v})} />
              <Inp label="Heure" value={form.heure} onChange={v => setForm({...form,heure:v})} placeholder="18h00" />
            </div>
            <Inp label="Lieu" value={form.lieu} onChange={v => setForm({...form,lieu:v})} placeholder="Salle de réunion – RDC" />
            <Sel label="Type d'assemblée" value={form.type} onChange={v => setForm({...form,type:v})}
              options={[{v:"AGO",l:"AGO — Assemblée Générale Ordinaire"},{v:"AGE",l:"AGE — Assemblée Générale Extraordinaire"}]} />
          </div>
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:18}}>Bureau de séance</h4>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>Président de séance</label>
              <select value={form.president} onChange={e => setForm({...form,president:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:"DM Sans",background:"#fff",color:C.text}}>
                <option value="">— Sélectionner —</option>
                {immRes.map(r => <option key={r.id} value={`${r.prenom} ${r.nom}`}>{r.prenom} {r.nom} ({r.apt})</option>)}
              </select>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>Secrétaire de séance</label>
              <select value={form.secretaire} onChange={e => setForm({...form,secretaire:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:"DM Sans",background:"#fff",color:C.text}}>
                <option value="">— Sélectionner —</option>
                {immRes.map(r => <option key={r.id} value={`${r.prenom} ${r.nom}`}>{r.prenom} {r.nom} ({r.apt})</option>)}
              </select>
            </div>
            <div style={{background:C.tealL,borderRadius:12,padding:"12px 14px",marginTop:8,fontSize:13,color:C.text}}>
              💡 Le quorum est atteint avec <strong>{Math.ceil(immRes.length/2)} copropriétaires</strong> présents sur {immRes.length}.
            </div>
          </div>
          <div style={{gridColumn:"1/-1",display:"flex",justifyContent:"flex-end"}}>
            <Btn onClick={() => setCurrentStep(2)} disabled={!form.titre||!form.date||!form.lieu}>
              Suivant : Présences →
            </Btn>
          </div>
        </div>
      )}

      {/* Step 2 – Présences */}
      {currentStep === 2 && (
        <div className="fi">
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>Feuille de présence</h4>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <span style={{fontSize:13,color:C.muted}}>{presentsIds.length}/{immRes.length} présents</span>
                <span style={{background:presentsIds.length>=Math.ceil(immRes.length/2)?C.tealL:"#fee2e2",
                  color:presentsIds.length>=Math.ceil(immRes.length/2)?C.teal:C.red,
                  padding:"4px 12px",borderRadius:20,fontSize:12,fontWeight:700}}>
                  {presentsIds.length >= Math.ceil(immRes.length/2) ? "✓ Quorum atteint" : "⚠ Quorum non atteint"}
                </span>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
              {immRes.map(r => {
                const present = presentsIds.includes(r.id);
                return (
                  <div key={r.id} onClick={() => setPresentsIds(p => present ? p.filter(x=>x!==r.id) : [...p,r.id])}
                    style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",borderRadius:12,cursor:"pointer",
                      border:`1.5px solid ${present?C.teal:C.border}`,
                      background:present?C.tealL:"#fff",transition:"all .15s"}}>
                    <div style={{width:36,height:36,borderRadius:"50%",background:present?`${C.teal}33`:`${C.muted}18`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,color:present?C.teal:C.muted}}>
                      {r.prenom[0]}{r.nom[0]}
                    </div>
                    <div style={{flex:1}}>
                      <p style={{fontWeight:600,color:C.text,fontSize:14}}>{r.prenom} {r.nom}</p>
                      <p style={{fontSize:12,color:C.muted}}>Apt. {r.apt} · {r.tantiemes} tantièmes</p>
                    </div>
                    <div style={{width:22,height:22,borderRadius:"50%",border:`2px solid ${present?C.teal:C.border}`,background:present?C.teal:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      {present && <span style={{color:"#fff",fontSize:12}}>✓</span>}
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:20}}>
              <Btn onClick={() => setCurrentStep(1)} outline>← Retour</Btn>
              <Btn onClick={() => setCurrentStep(3)}>Suivant : Points →</Btn>
            </div>
          </div>
        </div>
      )}

      {/* Step 3 – Points ordre du jour */}
      {currentStep === 3 && (
        <div className="fi" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:18}}>Ajouter un point</h4>
            <Inp label="Intitulé du point" value={newPoint.titre} onChange={v => setNewPoint({...newPoint,titre:v})} placeholder="Approbation du budget 2024..." />
            <Sel label="Type" value={newPoint.type} onChange={v => setNewPoint({...newPoint,type:v})}
              options={[{v:"vote",l:"🗳 Vote / Résolution"},{v:"info",l:"ℹ️ Information / Présentation"},{v:"question",l:"❓ Questions diverses"}]} />
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>Notes / Description</label>
              <textarea className="inp" rows={3} value={newPoint.notes} onChange={e => setNewPoint({...newPoint,notes:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,resize:"none"}}
                placeholder="Description ou contexte du point..." />
            </div>
            <Btn onClick={addPoint} disabled={!newPoint.titre.trim()}>+ Ajouter ce point</Btn>
          </div>
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:18}}>Ordre du jour ({points.length} points)</h4>
            {points.length === 0 ? (
              <div style={{textAlign:"center",padding:"30px 0",color:C.muted}}>
                <p style={{fontSize:32,marginBottom:8}}>📋</p>
                <p style={{fontSize:13}}>Aucun point ajouté</p>
              </div>
            ) : (
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {points.map((p, i) => (
                  <div key={p.id} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"12px 14px",borderRadius:12,background:C.bg,border:`1px solid ${C.border}`}}>
                    <span style={{width:22,height:22,borderRadius:"50%",background:C.teal,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0,marginTop:1}}>{i+1}</span>
                    <div style={{flex:1}}>
                      <p style={{fontWeight:600,color:C.text,fontSize:13}}>{p.titre}</p>
                      <span style={{fontSize:10,fontWeight:600,background:p.type==="vote"?C.blueL:p.type==="info"?"#fef3c7":"#f3f4f6",color:p.type==="vote"?C.blue:p.type==="info"?"#92400e":"#374151",padding:"2px 7px",borderRadius:8}}>{p.type==="vote"?"Résolution":p.type==="info"?"Information":"Questions diverses"}</span>
                    </div>
                    <button onClick={() => removePoint(p.id)} style={{background:"none",border:"none",cursor:"pointer",color:C.muted,fontSize:16}}>🗑️</button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{gridColumn:"1/-1",display:"flex",justifyContent:"space-between"}}>
            <Btn onClick={() => setCurrentStep(2)} outline>← Retour</Btn>
            <Btn onClick={() => setCurrentStep(4)} disabled={points.length===0}>Suivant : Votes →</Btn>
          </div>
        </div>
      )}

      {/* Step 4 – Votes */}
      {currentStep === 4 && (
        <div className="fi">
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:6}}>Votes & Résolutions</h4>
            <p style={{fontSize:13,color:C.muted,marginBottom:20}}>{presentsIds.length} votants présents. Saisissez les résultats de chaque vote.</p>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {points.map((p, i) => (
                <div key={p.id} style={{padding:"16px 18px",borderRadius:14,border:`1.5px solid ${C.border}`,background:"#fafbff"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:p.type==="vote"?14:0}}>
                    <span style={{width:26,height:26,borderRadius:"50%",background:C.teal,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,flexShrink:0}}>{i+1}</span>
                    <p style={{fontWeight:700,color:C.text,fontSize:14,flex:1}}>{p.titre}</p>
                    {p.type !== "vote" && <span style={{fontSize:12,color:C.muted,background:C.bg,padding:"3px 10px",borderRadius:8}}>Information</span>}
                  </div>
                  {p.type === "vote" && (
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10,marginLeft:36}}>
                      {[["pour","✅ Pour",C.green],["contre","❌ Contre",C.red],["abstention","⬜ Abstention",C.muted]].map(([field,label,color]) => (
                        <div key={field}>
                          <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:4}}>{label}</label>
                          <div style={{display:"flex",alignItems:"center",gap:6}}>
                            <button onClick={() => vote(p.id, field, p[field]-1)} style={{width:28,height:28,borderRadius:8,border:`1px solid ${C.border}`,background:"#fff",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>
                            <span style={{minWidth:28,textAlign:"center",fontWeight:700,fontSize:16,color:color}}>{p[field]}</span>
                            <button onClick={() => vote(p.id, field, p[field]+1)} style={{width:28,height:28,borderRadius:8,border:`1px solid ${C.border}`,background:"#fff",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                          </div>
                        </div>
                      ))}
                      <div>
                        <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:4}}>Résultat</label>
                        <span style={{display:"inline-block",padding:"6px 12px",borderRadius:8,fontSize:13,fontWeight:700,
                          background:p.pour>p.contre?"#d1fae5":p.pour<p.contre?"#fee2e2":"#f3f4f6",
                          color:p.pour>p.contre?"#065f46":p.pour<p.contre?"#991b1b":"#374151"}}>
                          {p.pour>p.contre?"✅ Approuvé":p.pour<p.contre?"❌ Rejeté":"— Nul"}
                        </span>
                      </div>
                    </div>
                  )}
                  {p.notes && <p style={{fontSize:12,color:C.muted,marginTop:10,marginLeft:36,fontStyle:"italic"}}>📝 {p.notes}</p>}
                </div>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:24}}>
              <Btn onClick={() => setCurrentStep(3)} outline>← Retour</Btn>
              <Btn onClick={saveAG} style={{background:`linear-gradient(135deg,${C.teal},#0ba882)`,boxShadow:"0 4px 16px rgba(14,201,164,.35)"}}>
                ✅ Clôturer & Générer le PV
              </Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  /* ─── DETAIL VIEW ─── */
  if (view === "detail" && selected) return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:22}}>
        <button className="btn" onClick={() => setView("list")}
          style={{padding:"8px 14px",borderRadius:10,background:C.bg,color:C.muted,fontWeight:600,fontSize:13}}>
          ← Retour
        </button>
        <div style={{flex:1}}>
          <h2 style={{fontSize:22,fontWeight:800,color:C.text}}>{selected.titre}</h2>
          <p style={{color:C.muted,fontSize:13}}>{fmtD(selected.date)} à {selected.heure} · {selected.lieu}</p>
        </div>
        <Btn onClick={() => setView("pv")} style={{background:`linear-gradient(135deg,${C.teal},#0ba882)`}}>
          📄 Voir le PV
        </Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:20}}>
        <div>
          <div style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)",marginBottom:16}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>Résultats des votes</h4>
            {selected.points.map((p, i) => (
              <div key={p.id} style={{padding:"14px 0",borderBottom:i<selected.points.length-1?`1px solid ${C.border}`:"none"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:p.type==="vote"?10:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{width:22,height:22,borderRadius:"50%",background:C.teal,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0}}>{i+1}</span>
                    <p style={{fontWeight:600,color:C.text,fontSize:14}}>{p.titre}</p>
                  </div>
                  {p.decision && (
                    <span style={{background:p.decision==="Approuvé"?"#d1fae5":p.decision==="Rejeté"?"#fee2e2":"#f3f4f6",
                      color:p.decision==="Approuvé"?"#065f46":p.decision==="Rejeté"?"#991b1b":"#374151",
                      padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700,flexShrink:0}}>
                      {p.decision}
                    </span>
                  )}
                </div>
                {p.type === "vote" && (
                  <div style={{display:"flex",gap:16,marginLeft:30,marginBottom:p.notes?6:0}}>
                    {[["✅",p.pour,"Pour",C.green],["❌",p.contre,"Contre",C.red],["⬜",p.abstention,"Abst.",C.muted]].map(([ic,n,l,color]) => (
                      <span key={l} style={{fontSize:13,color:color,fontWeight:600}}>{ic} {n} {l}</span>
                    ))}
                  </div>
                )}
                {p.notes && <p style={{fontSize:12,color:C.muted,marginTop:6,marginLeft:30,fontStyle:"italic"}}>📝 {p.notes}</p>}
              </div>
            ))}
          </div>
        </div>
        <div>
          <div style={{background:C.card,borderRadius:16,padding:20,boxShadow:"0 2px 14px rgba(11,19,51,.06)",marginBottom:14}}>
            <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:14}}>Bureau & Présences</h4>
            {[["🏛️","Président",selected.president],["📝","Secrétaire",selected.secretaire]].map(([ic,l,v]) => (
              <div key={l} style={{display:"flex",gap:8,padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                <span>{ic}</span><div><p style={{fontSize:11,color:C.muted}}>{l}</p><p style={{fontSize:14,fontWeight:600,color:C.text}}>{v}</p></div>
              </div>
            ))}
            <div style={{marginTop:14}}>
              <p style={{fontSize:11,color:C.muted,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Présents ({selected.presentsIds.length})</p>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {immRes.filter(r => selected.presentsIds.includes(r.id)).map(r => (
                  <div key={r.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}>
                    <div style={{width:26,height:26,borderRadius:"50%",background:C.tealL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:C.teal}}>{r.prenom[0]}{r.nom[0]}</div>
                    <span style={{color:C.text,fontWeight:500}}>{r.prenom} {r.nom}</span>
                    <span style={{color:C.muted,fontSize:11}}>({r.apt})</span>
                  </div>
                ))}
                {immRes.filter(r => !selected.presentsIds.includes(r.id)).map(r => (
                  <div key={r.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:13,opacity:.5}}>
                    <div style={{width:26,height:26,borderRadius:"50%",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:C.muted}}>{r.prenom[0]}{r.nom[0]}</div>
                    <span style={{color:C.muted}}>{r.prenom} {r.nom}</span>
                    <span style={{fontSize:10,color:C.muted,background:"#fee2e2",color:"#991b1b",padding:"1px 6px",borderRadius:6}}>Absent</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  /* ─── PV VIEW ─── */
  if (view === "pv" && selected) {
    const presRes = immRes.filter(r => selected.presentsIds.includes(r.id));
    const absentRes = immRes.filter(r => !selected.presentsIds.includes(r.id));
    const approuves = selected.points.filter(p => p.decision === "Approuvé").length;
    const rejetes   = selected.points.filter(p => p.decision === "Rejeté").length;

    return (
      <div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:22}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button className="btn" onClick={() => setView(pvMode?"list":"detail")}
              style={{padding:"8px 14px",borderRadius:10,background:C.bg,color:C.muted,fontWeight:600,fontSize:13}}>
              ← Retour
            </button>
            <div>
              <h2 style={{fontSize:20,fontWeight:800,color:C.text}}>Procès-Verbal</h2>
              <p style={{color:C.muted,fontSize:13}}>{selected.titre}</p>
            </div>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button className="btn" onClick={() => alert("📄 PV exporté en PDF !\n(Export réel disponible avec jsPDF dans la version production)")}
              style={{padding:"9px 18px",borderRadius:10,background:"#fee2e2",color:C.red,fontWeight:600,fontSize:13}}>
              📥 PDF
            </button>
            <Btn onClick={() => alert("📧 PV envoyé à tous les copropriétaires !")}
              style={{background:`linear-gradient(135deg,${C.teal},#0ba882)`}}>
              📧 Envoyer aux copropriétaires
            </Btn>
          </div>
        </div>

        {/* PV Document */}
        <div style={{background:"#fff",borderRadius:16,padding:"40px 48px",boxShadow:"0 2px 24px rgba(11,19,51,.1)",maxWidth:800,margin:"0 auto",fontFamily:"'DM Sans',sans-serif"}}>
          {/* Header */}
          <div style={{textAlign:"center",borderBottom:`2px solid ${C.navy}`,paddingBottom:24,marginBottom:28}}>
            <div style={{display:"flex",justifyContent:"center",marginBottom:12}}><RFLogo size={40}/></div>
            <p style={{fontSize:11,fontWeight:700,color:C.muted,letterSpacing:"2px",textTransform:"uppercase",marginBottom:4}}>Procès-Verbal</p>
            <h1 style={{fontSize:22,fontWeight:800,color:C.navy,marginBottom:6}}>{selected.titre}</h1>
            <p style={{fontSize:13,color:C.muted}}>{imm?.nom} · {imm?.adresse}</p>
          </div>

          {/* Infos séance */}
          <div style={{background:C.bg,borderRadius:12,padding:"14px 18px",marginBottom:24}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
              {[["📅 Date",fmtD(selected.date)],["⏰ Heure",`${selected.heure}`],["📍 Lieu",selected.lieu]].map(([l,v]) => (
                <div key={l}>
                  <p style={{fontSize:11,color:C.muted,fontWeight:600,marginBottom:2}}>{l}</p>
                  <p style={{fontSize:13,color:C.text,fontWeight:600}}>{v}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Bureau */}
          <div style={{marginBottom:24}}>
            <h3 style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:10,paddingBottom:6,borderBottom:`1px solid ${C.border}`}}>I. BUREAU DE SÉANCE</h3>
            <p style={{fontSize:13,color:C.text,lineHeight:1.8}}>
              L'assemblée est présidée par <strong>{selected.president || "—"}</strong>.<br/>
              Les fonctions de secrétaire sont assurées par <strong>{selected.secretaire || "—"}</strong>.
            </p>
          </div>

          {/* Présences */}
          <div style={{marginBottom:24}}>
            <h3 style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:10,paddingBottom:6,borderBottom:`1px solid ${C.border}`}}>II. FEUILLE DE PRÉSENCE</h3>
            <p style={{fontSize:13,color:C.text,marginBottom:10}}>
              <strong>{presRes.length}</strong> copropriétaires présents sur <strong>{immRes.length}</strong> — représentant{" "}
              <strong>{presRes.reduce((a,r)=>a+r.tantiemes,0)}</strong> tantièmes sur <strong>{imm?.total}</strong>.
              {selected.quorum
                ? <span style={{color:"#065f46",fontWeight:600}}> ✓ Quorum atteint.</span>
                : <span style={{color:C.red,fontWeight:600}}> ⚠ Quorum non atteint.</span>}
            </p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:8}}>
              {presRes.map(r => (
                <div key={r.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,padding:"4px 0"}}>
                  <span style={{color:C.green,fontWeight:700}}>✓</span>
                  <span style={{color:C.text}}><strong>{r.prenom} {r.nom}</strong> — Apt. {r.apt} ({r.tantiemes} tantièmes)</span>
                </div>
              ))}
              {absentRes.map(r => (
                <div key={r.id} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,padding:"4px 0",opacity:.6}}>
                  <span style={{color:C.muted}}>✗</span>
                  <span style={{color:C.muted}}>{r.prenom} {r.nom} — Apt. {r.apt} (absent)</span>
                </div>
              ))}
            </div>
          </div>

          {/* Ordre du jour & Délibérations */}
          <div style={{marginBottom:24}}>
            <h3 style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:10,paddingBottom:6,borderBottom:`1px solid ${C.border}`}}>III. ORDRE DU JOUR ET DÉLIBÉRATIONS</h3>
            {selected.points.map((p, i) => (
              <div key={p.id} style={{marginBottom:18,paddingBottom:18,borderBottom:i<selected.points.length-1?`1px dashed ${C.border}`:"none"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                  <h4 style={{fontSize:13,fontWeight:700,color:C.navy}}>Point {i+1} — {p.titre}</h4>
                  {p.decision && (
                    <span style={{background:p.decision==="Approuvé"?"#d1fae5":"#fee2e2",
                      color:p.decision==="Approuvé"?"#065f46":"#991b1b",
                      padding:"3px 12px",borderRadius:20,fontSize:11,fontWeight:700,flexShrink:0,marginLeft:12}}>
                      {p.decision}
                    </span>
                  )}
                </div>
                {p.type === "vote" && (
                  <div style={{background:C.bg,borderRadius:8,padding:"8px 12px",marginBottom:p.notes?8:0}}>
                    <p style={{fontSize:12,color:C.muted,marginBottom:4}}>Résultat du vote :</p>
                    <div style={{display:"flex",gap:16,fontSize:13}}>
                      <span style={{color:C.green,fontWeight:600}}>Pour : {p.pour}</span>
                      <span style={{color:C.red,fontWeight:600}}>Contre : {p.contre}</span>
                      <span style={{color:C.muted,fontWeight:600}}>Abstention : {p.abstention}</span>
                    </div>
                  </div>
                )}
                {p.notes && <p style={{fontSize:12,color:C.text,lineHeight:1.7,marginTop:6,fontStyle:"italic"}}>"{p.notes}"</p>}
              </div>
            ))}
          </div>

          {/* Résumé */}
          <div style={{background:`${C.tealL}`,borderRadius:12,padding:"14px 18px",marginBottom:28}}>
            <p style={{fontSize:13,fontWeight:700,color:C.teal,marginBottom:6}}>Récapitulatif des votes</p>
            <div style={{display:"flex",gap:20,fontSize:13}}>
              <span style={{color:C.green,fontWeight:600}}>✅ Approuvés : {approuves}</span>
              <span style={{color:C.red,fontWeight:600}}>❌ Rejetés : {rejetes}</span>
              <span style={{color:C.muted,fontWeight:600}}>ℹ️ Informations : {selected.points.filter(p=>p.type!=="vote").length}</span>
            </div>
          </div>

          {/* Clôture */}
          <div style={{marginBottom:32}}>
            <h3 style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:10,paddingBottom:6,borderBottom:`1px solid ${C.border}`}}>IV. CLÔTURE DE LA SÉANCE</h3>
            <p style={{fontSize:13,color:C.text,lineHeight:1.8}}>
              L'ordre du jour étant épuisé, la séance est levée à {selected.heure}.<br/>
              Le présent procès-verbal est établi et signé par le président et le secrétaire de séance.
            </p>
          </div>

          {/* Signatures */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:40,marginTop:20,paddingTop:20,borderTop:`1px solid ${C.border}`}}>
            {[["Le Président de séance",selected.president],["Le Secrétaire de séance",selected.secretaire]].map(([role,nom]) => (
              <div key={role} style={{textAlign:"center"}}>
                <p style={{fontSize:12,color:C.muted,marginBottom:40}}>{role}</p>
                <div style={{borderTop:`1px solid ${C.text}`,paddingTop:8}}>
                  <p style={{fontSize:13,fontWeight:600,color:C.text}}>{nom || "—"}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{textAlign:"center",marginTop:24,paddingTop:16,borderTop:`1px solid ${C.border}`}}>
            <p style={{fontSize:11,color:C.muted}}>Document généré par RésiFlow · resiflow.ma · {fmtD(new Date().toISOString())}</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

